import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import * as express from 'express';
import { AppConfig } from '../app.config';

export enum Level {
    Fatal = 'Fatal',
    Error = 'Error',
    Warning = 'Warning',
    Debug = 'Debug',
    Info = 'Info'
}

export class Logger {
    constructor(private name: string, private maxLoggingLevel: Level, private http: HttpClient, private appConfig: AppConfig) { }

    public async fatal(msg: string, stack?: any) {
        await this.log(Level.Fatal, msg, stack);
    }

    public async error(msg: string, stack?: any) {
        await this.log(Level.Error, msg, stack);
    }

    public async warn(msg: string, stack?: any) {
        await this.log(Level.Warning, msg, stack);
    }

    public async info(msg: string, stack?: any) {
        await this.log(Level.Info, msg, stack);
    }

    public async debug(msg: string, stack?: any) {
        await this.log(Level.Debug, msg, stack);
    }

    public setMaxLoggingLevel(level: Level) {
        this.maxLoggingLevel = level;
    }

    private async log(level: Level, msg: string, stack?: any) {
        if (this.checkIfShouldLog(level)) {
            let body = {
                level,
                name: this.name,
                msg,
                stack: stack ? stack : undefined
            };

            let logUrl = this.appConfig.getApiUrl('/log');

            if (this.appConfig.isProduction) {
                this.http.post(logUrl, body);
            } else {
                this.consoleLog(level, msg, stack);
            }
        }
    }

    private consoleLog(level: Level, msg: string, stack?: any) {
        switch (level) {
            case Level.Debug:
                // tslint:disable-next-line:no-console
                console.debug(msg, stack);
                break;
            case Level.Info:
                // tslint:disable-next-line:no-console
                console.log(msg, stack);
                break;
            case Level.Warning:
                // tslint:disable-next-line:no-console
                console.warn(msg, stack);
                break;
            case Level.Error:
                // tslint:disable-next-line:no-console
                console.error(msg, stack);
                break;
            case Level.Fatal:
                // tslint:disable-next-line:no-console
                console.error(msg, stack);
                break;
        }
    }

    private checkIfShouldLog(level: Level) {
        switch (this.maxLoggingLevel) {
            case Level.Info:
                return !(level === Level.Debug);
            case Level.Warning:
                return !(level === Level.Debug || level === Level.Info);
            case Level.Error:
                return level === Level.Error || level === Level.Fatal;
            case Level.Fatal:
                return level === Level.Fatal;
            default:
                return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/logger.ts